import { useEffect, useState } from 'react'

export const useIsHovered = (ref: React.RefObject<HTMLElement>) => {
  const [isHovered, setIsHovered] = useState(false)

  useEffect(() => {
    const element = ref.current
    const handleMouseEnter = () => setIsHovered(true)
    const handleMouseLeave = () => setIsHovered(false)

    element?.addEventListener('mouseenter', handleMouseEnter)
    element?.addEventListener('mouseleave', handleMouseLeave)

    return () => {
      element?.removeEventListener('mouseenter', handleMouseEnter)
      element?.removeEventListener('mouseleave', handleMouseLeave)
    }
  }, [ref])

  return isHovered
}
